module.exports = __webpack_public_path__ + "static/media/WarmShadow.bbd14ab1.jpg";